import React, { useState } from "react";
import { isDarkTheme } from "segments/segments-service";
import { componentStyles } from "./monday-integrations-connections-component.scss";
import PictureComponent from "/components/core/picture/picture-component";
import classnames from "classnames";
import Switch from "/components/core/switch/switch";
import DefaultProps from "./default-props";
import {
  LIGHT_WORK_OS_IRIS_COLOR_NAME,
  WORK_OS_IRIS_COLOR_NAME,
  BACKGROUND_GRAY_COLOR_NAME,
  WHITE_COLOR_NAME,
  BLACK_COLOR_NAME
} from "styles/color-consts";
import Colors from "styles/colors";
import { withGenericConfig } from "/contexts/generic-config-context";
import Title from "segments/desktop/core-components/title/title";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";

const MondayIntegrationsConnectionsComponent = (props) => {
  const { theme,componentTitle, beforeAnimationSubTitle ,afterAnimationSubTitle, switchRightPhrase ,switchLeftPhrase } = props;
  const lineColor = isDarkTheme(theme)
    ? Colors[WHITE_COLOR_NAME]
    : Colors[BLACK_COLOR_NAME];
  const iconsArray = [
    {
      iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-1.png",
      startLocation: [0, 250],
      endLocation: [50, 100]
    },
    {
      iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-2.png",
      startLocation: [200, 100],
      endLocation: [50, 250]
    },
    {
      iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-3.png",
      startLocation: [200, 450],
      endLocation: [50, 400]
    },
    {
      iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-4.png",
      startLocation: [400, 250],
      endLocation: [50, 550]
    },
    {
      iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-5.png",
      startLocation: [500, 450],
      endLocation: [850, 100]
    },
    {
      iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-6.png",
      startLocation: [600, 100],
      endLocation: [850, 250]
    },
    {
      iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-7.png",
      startLocation: [800, 100],
      endLocation: [850, 400]
    },
    {
      iconImage: "https://dapulse-res.cloudinary.com/image/upload/Integration_assets/Integrations-icon-8.png",
      startLocation: [800, 450],
      endLocation: [850, 550]
    }
  ];

  const [animationIsOn, setAnimationState] = useState(false);

  const ICON_HEIGHT = 82;
  const ICON_WIDTH = 75;

  const changeAnimationState = () => {
    setAnimationState(!animationIsOn);
  };

  const renderLine = (x1, x2, y1, y2) => {
    return <line stroke-dasharray="3" x1={x1} y1={x2} x2={y1} y2={y2} stroke={lineColor} />;
  };


  const drawLineBetweenIcons = (icon1index, icon2index) => {
    if(iconsArray[icon1index].startLocation[0]===iconsArray[icon2index].startLocation[0]){
      return(
      renderLine(
        iconsArray[icon1index].startLocation[0] + ICON_WIDTH / 2 + "px",
        iconsArray[icon1index].startLocation[1] +ICON_HEIGHT + "px",
        iconsArray[icon2index].startLocation[0] + ICON_WIDTH / 2 + "px",
        iconsArray[icon2index].startLocation[1]  + "px"
      ))
    }else if(iconsArray[icon1index].startLocation[1]===iconsArray[icon2index].startLocation[1]){
      return(
      renderLine(
        iconsArray[icon1index].startLocation[0] + ICON_WIDTH  + "px",
        iconsArray[icon1index].startLocation[1] +ICON_HEIGHT /2 + "px",
        iconsArray[icon2index].startLocation[0]  + "px", 
        iconsArray[icon2index].startLocation[1] + ICON_HEIGHT /2 + "px"))
      }
  };

  const drawHorizontalLine = (startIconIndex, xEnd) => {
    return(
    renderLine(
      iconsArray[startIconIndex].startLocation[0] + ICON_WIDTH  + "px",
      iconsArray[startIconIndex].startLocation[1] + ICON_HEIGHT / 2 + "px",
      iconsArray[xEnd].startLocation[0] + ICON_WIDTH / 2 + "px",
      iconsArray[startIconIndex].startLocation[1] + ICON_HEIGHT / 2 + "px"
    ))
  }

  const drawVerticalLine = (startIconIndex, yEnd) => {
    return(
    renderLine(
      iconsArray[startIconIndex].startLocation[0] + ICON_WIDTH /2 + "px",
      iconsArray[startIconIndex].startLocation[1] +ICON_HEIGHT + "px",
      iconsArray[startIconIndex].startLocation[0] + ICON_WIDTH /2 + "px",
      iconsArray[yEnd].startLocation[1] + ICON_HEIGHT /2 + "px"
    ))
  }

  

  const renderIcons = () => {
    return iconsArray.map((icon) => (
      <div
        className="icon"
        style={{
          "--x-before": `${icon.startLocation[0]}px`,
          "--y-before": `${icon.startLocation[1]}px`,
          "--x-after": `${icon.endLocation[0]}px`,
          "--y-after": `${icon.endLocation[1]}px`
        }}
      >
        <PictureComponent src={icon.iconImage} />
        <style jsx>{componentStyles}</style>
      </div>
    ));
  };

  const switchbackground = isDarkTheme(theme)
    ? Colors[BACKGROUND_GRAY_COLOR_NAME]
    : Colors[LIGHT_WORK_OS_IRIS_COLOR_NAME];


  return (
    <div className="monday-integrations-connections-component">
      <div className={classnames("monday-integrations-wrapper", { animation: animationIsOn })}>
      <div className="title-wrapper">
      <Title
        title={componentTitle}
        />
        </div>
        <div className="switch-wrapper">
          <Switch
            handleToggle={changeAnimationState}
            leftPhrase={switchLeftPhrase}
            rightPhrase={switchRightPhrase}
            switchBackgroundColor={switchbackground}
            switchButtonColor={Colors[WORK_OS_IRIS_COLOR_NAME]}
            IsOnRightTextColor={WHITE_COLOR_NAME}
            IsOffRightTextColor={BLACK_COLOR_NAME}
            IsOnLeftTextColor={BLACK_COLOR_NAME}
            IsOffLeftTextColor={WHITE_COLOR_NAME}
            isOn={animationIsOn}
          />
        </div>
        <div className="before-animation-paragraph-wrapper">
        <Paragraph body={beforeAnimationSubTitle}/>
        </div>
        <div className="after-animation-paragraph-wrapper">
        <Paragraph body={afterAnimationSubTitle}/>
        </div>

        <div className="monday-logo">
          <PictureComponent
            src="https://dapulse-res.cloudinary.com/image/upload/Integration_assets/monday-logo.png"
          />
        </div>
        <div className="icons-and-lines-wrapper"  >
        {renderIcons()}
        <svg width="1000px" height="1000px" className="line" id="lines-svg">
          {drawLineBetweenIcons(1,2)}
          {drawLineBetweenIcons(1,5)}
          {drawLineBetweenIcons(2,4)}
          {drawLineBetweenIcons(4,7)}
          {drawLineBetweenIcons(6,7)}
          {drawHorizontalLine(0,1)}
          {drawVerticalLine(3,2)}
        </svg>
        </div>
        
      </div>

      <style jsx>{componentStyles}</style>
    </div>
  );
};

MondayIntegrationsConnectionsComponent.defaultProps = DefaultProps;

export default withGenericConfig(MondayIntegrationsConnectionsComponent);
